import React, {Component} from 'react';
import {LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Brush} from 'recharts';
import * as formatter from "../utils/formatters";
import {GRAPH_MARGIN} from "../utils/constants";

class GlobalPortfolioReduceGraph extends Component {

  constructor(props){
    super(props);
  }

  render(){
    return(
      <ResponsiveContainer>
        <LineChart width={600} height={300} data={this.props.data} margin={GRAPH_MARGIN}>
          <XAxis dataKey = "month"/>
          <YAxis tickFormatter={formatter.formatNumber} scale={'linear'}/>
          <CartesianGrid/>
          <Tooltip formatter={formatter.formatNumber}/>
          <Legend verticalAlign={"top"}/>
          <Line name={"CUENTAS"} type="linear" dataKey="accoutns" stroke="#222" />
          <Brush height={20}/>
        </LineChart>
      </ResponsiveContainer>
    );
  }
}

export default GlobalPortfolioReduceGraph;



// WEBPACK FOOTER //
// ./src/charts/globalPortfolioReduceGraph.js